import { Section, SectionHeader } from "@/components/ui/Section";
import { StaggerChildren, StaggerItem } from "@/components/ui/AnimatedSection";
import { Compass, GaugeCircle, FileText, ShieldCheck, UserCheck } from "lucide-react";

const cards = [
  {
    icon: Compass,
    title: "Discovery & Solution Architecture",
    body:
      "Every engagement begins with a structured discovery of business goals, operating reality and technical constraints before any solution is proposed. Architecture decisions are documented, justified and mapped to business outcomes.",
  },
  {
    icon: GaugeCircle,
    title: "Governance & Delivery Cadence",
    body:
      "Weekly leadership cadence, milestone tracking, decision logs and clear escalation paths. Leadership always knows where a workstream stands and what the next material decision is.",
  },
  {
    icon: FileText,
    title: "Documentation & Knowledge Transfer",
    body:
      "Architecture diagrams, decision records, runbooks and handover documents. Internal teams retain the operating knowledge, not the vendor. Nothing becomes hostage to a single relationship.",
  },
  {
    icon: ShieldCheck,
    title: "Security & Compliance Awareness",
    body:
      "Data handling, access control, secrets management, tenancy and regulatory posture are considered at design time, not after audit. Sensible defaults for founder-led companies moving toward enterprise conversations.",
  },
  {
    icon: UserCheck,
    title: "Senior-Led Execution Model",
    body:
      "Senior technology and AI leaders stay in the room from strategy to execution. Engagements are not handed off to junior teams once the proposal is signed.",
  },
];

export function EnterpriseReadySection() {
  return (
    <Section background="dark" spacing="default">
      <SectionHeader
        eyebrow="Enterprise-Ready Delivery"
        title="How we operate when the stakes are real."
        subtitle="A senior operating rhythm that larger companies expect and founder-led teams benefit from."
        variant="dark"
        align="center"
      />
      <StaggerChildren className="grid md:grid-cols-2 lg:grid-cols-3 gap-5" staggerDelay={0.07}>
        {cards.map((c) => (
          <StaggerItem key={c.title}>
            <div className="group relative h-full rounded-2xl border border-white/10 bg-white/[0.04] backdrop-blur-md p-7 transition-all duration-500 hover:border-white/25 hover:bg-white/[0.07] hover:-translate-y-1.5">
              <div className="w-12 h-12 rounded-xl bg-white/10 border border-white/15 grid place-items-center mb-5 group-hover:bg-accent/15 group-hover:border-accent/40 transition-colors">
                <c.icon className="h-5 w-5 text-accent" strokeWidth={1.6} />
              </div>
              <h3 className="font-display font-semibold text-lg mb-3 text-white">{c.title}</h3>
              <p className="text-sm text-white/65 leading-[1.75]">{c.body}</p>
            </div>
          </StaggerItem>
        ))}
      </StaggerChildren>
    </Section>
  );
}
